import { usePendingReviewsCount } from '~/hooks/use-reviews';
import { useHasAccess } from '~/lib/auth/use-has-access';

/**
 * Customer comments waiting for moderation, beside the Reviews menu entry (BW-3930). Polls every minute and refreshes
 * with the reviews page (shared `reviews` key root). Only Catalog users ask (the endpoint's role); nothing at zero.
 */
export function PendingReviewsCountBadge() {
	const canModerate = useHasAccess()('Catalog');
	const { data: pending = 0 } = usePendingReviewsCount(canModerate);
	if (!canModerate || pending === 0) return null;

	return (
		<span className="ml-auto rounded-pill bg-warning px-1.5 py-px text-[10px] font-semibold tabular-nums text-warning-fg">{pending}</span>
	);
}
